import LocalizedStrings from 'react-localization';
import { withCommon } from '../../../services/translation/commonTranslations';

const upcomingShiftStrings = new LocalizedStrings({
  en: {
    nextShiftTitle: 'My Next Shift',
    yourNextShift: 'Your next shift is:',
    viewButton: 'View Details',
    startEndTime: (start: string, end: string) => `${start} - ${end}`
  }
});

export default withCommon<typeof upcomingShiftStrings>(upcomingShiftStrings);
